import { styled } from '@mui/material'

export const SingleSheetWrapper = styled('div')({
  width: '100%',
  height: 'calc(100% - 100px)',
  padding: '4px',
})
